const PREFIX = 'tandemone.banner.'

/** dismissing an app-wide banner is permanent, and scoped to the user who did
 *  it: the ids below carry the user id, so a shared machine never hides one
 *  person's notice from the next.
 *
 *  storage is per-browser, so the same user on a second device sees it again.
 */
export function isBannerDismissed(id: string): boolean {
  try {
    return window.localStorage.getItem(PREFIX + id) !== null
  } catch {
    /* private mode denies storage, so the banner simply stays. */
    return false
  }
}

export function dismissBanner(id: string): void {
  try {
    window.localStorage.setItem(PREFIX + id, '1')
  } catch {
    /* nothing to fall back to: the banner reappears on the next render. */
  }
}
